<template>
<div class="page-wrapper">
  <div v-if="contractBaseVo">
    <h3 class="title">基本信息</h3>
    <Row>
        <Col span="8">合同号：<span class="info">{{contractBaseVo.contractCode}}</span></Col>
        <Col span="8">项目名称：<span class="info">{{contractBaseVo.projectName}}</span></Col>
        <Col span="8">房间号：<span class="info">{{contractBaseVo.roomNumber}}</span></Col>
        <Col span="8">客户名称：<span class="info">{{contractBaseVo.customerName}}</span></Col>
        <Col span="8">开始日期：<span class="info">{{formatDateTime(contractBaseVo.conStartDate,false)}}</span></Col>
        <Col span="8">结束日期：<span class="info">{{formatDateTime(contractBaseVo.conEndDate,false)}}</span></Col>
      </Row>
  </div>
  <div class="mt36" >
    <h4 class="title">账单信息</h4>
    <Row class="mb16" :gutter="16" v-if="receiptBill">
      <Col span="8">账单编号：<span class="info">{{receiptBill.billNum}}</span></Col>
      <Col span="8">单据状态：<span class="info">{{receiptBill.verificateStatusName}}</span></Col>
      <Col span="8">计划收款日期：<span class="info">{{receiptBill.preCollectionDate}}</span></Col>
    </Row>
    <div class="table-wrap" v-if="receiptBill">
      <table class="ivu-table" cellspacing="0" cellpadding="0" border="0" >
        <thead>
          <tr>
            <th>费用项</th>
            <th>应收金额</th>
            <th>实收金额</th>
            <th>未收金额</th>
          </tr>
        </thead>
      <tbody>
          <tr>
            <td class="ivu-table-column-center">{{receiptBill.costCodeName}}</td>
            <td class="ivu-table-column-center">{{receiptBill.receiptBillAmount}}</td>
            <td class="ivu-table-column-center">{{receiptBill.receivedBillAmount}}</td>
            <td class="ivu-table-column-center">{{receiptBill.unreceiveBillAmount}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div  class="mt36" v-if="receiptList && receiptList.length">
    <h3 class="title">收款单信息</h3>

      <div class="mb16 inline-b" v-for ="(billItem,i) in receiptList">
        <ul>
          <li><p>收款单号：<span>{{billItem.receiptNum}}</span></p></li>
          <li><p>收款金额：<span class="error-color">{{billItem.amount}}</span>元</p></li>
          <li><p>实际支付日期：<span>{{billItem.payTime}}</span></p></li>
          <li>
            <p class="half-w">收款方式：<span>{{billItem.paymentTypeName ? billItem.paymentTypeName: billItem.paymentTypeCode}}</span></p>
           <p class="half-w">付款人：<span>{{billItem.payer}}</span></p>
          </li>
          <li>
            <p>{{getPaySerialLable(billItem.paymentTypeCode)}}<span>{{billItem.paySerialNum}}</span></p>
          </li>
          <li><p>备注：<span>{{billItem.remark}}</span></p></li>
        </ul>
      </div>
    </div>
  <!--</div>-->
</div>

</template>

<script type="text/ecmascript-6">
import { formatDateTime } from '@/utils/format'
import { getBillInfo } from 'api/accountsReceivable'

export default {
  name:'accountsreceivabledetail',
  created(){
    this.billNumber = this.$route.query.bNum
    this.contractCode = this.$route.query.cCode
    this.getBillInfo()
  },
  activated(){
    if(this.isActive){
      this.billNumber = this.$route.query.bNum
      this.contractCode = this.$route.query.cCode
      this.getBillInfo()
    }
    this.isActive = true
  },
  data () {
    return {
      isActive:false,
      imgSrc:'',
      billNumber:'',
      verificateStatus:'',
      contractCode:'',
      receiptBillAmount:0,
      receivedBillAmount:0,
      contractBaseVo:null,
      receiptBill:null,
      receiptList:null,
      cardsList:[],
      billInfo:null,

    };
  },
  methods:{
    getBillInfo(){
      getBillInfo(this.contractCode,this.billNumber).then( res => {
        this.contractBaseVo = res.data.contractBaseVo
        this.receiptBill = res.data.receiptBill
        this.receiptList = res.data.receiptList
      })
    },
    formatDateTime:formatDateTime,
    getPaymentType(code){
      let type = 0 // type:0银行，1pos机，2支票,3虚拟抵扣,
      let patternYh = /^yhzz/
      let patternZp = /^zp/
      let patternPos = /^pos/
      let patternXndk = /^mzjxndk/
      if(patternYh.test(code)){
        type = 0
      } else if(patternPos.test(code)){
        type = 1
      } else if(patternZp.test(code)){
        type = 2
      }else if(patternXndk.test(code)){
        type = 3
      }
      return type
    },
    getPaySerialLable(code){
      //let type = 0 // type:0银行，1pos机，2支票,3虚拟抵扣,
      let label = ''
      let patternYh = /^yhzz/
      let patternZp = /^zp/
      let patternPos = /^pos/
      let patternXndk = /^mzjxndk/
      if(patternYh.test(code)){
        //type = 0
        label = '付款账号：'
      } else if(patternPos.test(code)){
       // type = 1
        label = '参考号：'
      } else if(patternZp.test(code)){
        //type = 2
        label='支票号：'
      }else if(patternXndk.test(code)){
       // type = 3
        label = 'OA审批申请号：'
      }else{
        label = '流水号：'
      }
      return label
    },
  }
}
</script>

<style lang="css" scoped>
 .table-wrap {
  position: relative;
  border: 1px solid #dddee1;
  border-bottom: 0;
  border-right: 0;
}
table {
  width: 100%;
}
th,td {
  text-align: center;
}
.btn-wrap {
width: 100%;
text-align: center;
}
.cards {
  display: inline-block;
  width:80px;
  height: 32px;
  line-height: 32px;
  border: 1px solid #DDDEE1;
  border-radius: 2px;
  text-align: center;
  margin-left: 16px;
}
.cards.checked {
 border: 1px solid #CFA868;
}
.half-w {
  width: 50%;
}
ul {
  display: inline-block;
  border:1px solid #DDDEE1;
  min-width: 400px;
  padding: 24px;
  margin-right: 16px;
}
li {
  display: flex;
  width: 100%;
  line-height: 2;
}
.info {
  padding-left: 8px;
  font-weight: 600;
}
.ivu-col {
  line-height: 2.5;
}
</style>
